import { Gallery_Navigation_default } from "./chunk-AKWW4SLC.js";
import { Gallery_Root_default } from "./chunk-FPOSG4SL.js";
import { Gallery_default } from "./chunk-C5PLDSAO.js";
import { Gallery_Button_default } from "./chunk-ONTSML6G.js";
import { Gallery_Item_default } from "./chunk-7ECGVLWC.js";
import { Gallery_Navigation_MoreButton_default } from "./chunk-EKQ7I3VI.js";
import { Gallery_Navigation_Item_default } from "./chunk-5YTXFOS2.js";

// src/components/Gallery/index.ts
var GalleryNavigationComponent = Gallery_Navigation_default;
GalleryNavigationComponent.Item = Gallery_Navigation_Item_default;
GalleryNavigationComponent.Item.displayName = "Gallery.Navigation.Item";
GalleryNavigationComponent.MoreButton = Gallery_Navigation_MoreButton_default;
GalleryNavigationComponent.MoreButton.displayName = "Gallery.Navigation.MoreButton";
var GalleryComponent = Gallery_default;
GalleryComponent.Button = Gallery_Button_default;
GalleryComponent.Button.displayName = "Gallery.Button";
GalleryComponent.Root = Gallery_Root_default;
GalleryComponent.Root.displayName = "Gallery.Root";
GalleryComponent.Items = Gallery_Root_default;
GalleryComponent.Items.displayName = "Gallery.Items";
GalleryComponent.Item = Gallery_Item_default;
GalleryComponent.Item.displayName = "Gallery.Item";
GalleryComponent.Navigation = GalleryNavigationComponent;
GalleryComponent.Navigation.displayName = "Gallery.Navigation";
export { GalleryComponent };